import React from 'react';
import {List, Avatar, Skeleton} from 'antd';
import IconText from "./IcontText";


class ListItem extends React.Component {
    render() {
        const {item} = this.props;
        var resUrl = item.resUrls;
        if (item.resUrls!=null){
            resUrl=item.resUrls.split(",")[0];
        }
        if (resUrl!=null&&!resUrl.startsWith("http")){
            resUrl="https://github.com/" + resUrl;
        }
        return (
            <List.Item
                key={item.name}
                actions={[
                    <IconText type="star-o" text={item.stargazersCount} key="list-vertical-star-o"/>,
                ]}
                extra={
                    <img
                        width={100}
                        height={100}
                        alt="logo"
                        src={resUrl}

                    />
                }
            >
                <Skeleton avatar title={false} loading={item.loading} active>
                    <List.Item.Meta
                        avatar={<Avatar src={item.ownerAvatarUrl}/>}
                        title={<a href={`https://github.com/${item.ownerLogin}/${item.name}`}>{item.name}</a>}
                        description={item.description}
                    />
                    {item.content}
                </Skeleton>
            </List.Item>
        )
    }
}

export default ListItem;
